import React from 'react';
import { useFeatureFlagQuery } from '@leagueplatform/user-profile-api';
import { FEATURE_FLAGS } from 'common/constants';
import { RegionSelectionBanner } from '../region-selection-banner.component';

type RegionSelectionHomeProps = {
  onClick?: () => void;
};

export function RegionSelectionHome({ onClick }: RegionSelectionHomeProps) {
  const { data: isHomeScreenEnhancementsEnabled } = useFeatureFlagQuery(
    FEATURE_FLAGS.ENABLE_HOME_SCREEN_ENHANCEMENTS,
  );
  const top = isHomeScreenEnhancementsEnabled ? '-36px' : '-66px';
  const css = isHomeScreenEnhancementsEnabled
    ? { top }
    : {
        top,
        '@laptop': { top: `calc(${top} - 22px)` },
        '@desktop': { top: `calc(${top} - 22px)` },
      };

  return <RegionSelectionBanner css={css} onClick={onClick} />;
}
